module.exports = __webpack_public_path__ + "img/download.95932f40.png";